const initialState = {
  defaultColDefs: {
    sortable: true,
    filter: true,
    resizable: true,
  },
};

const killshotReport = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default killshotReport;
